import { Diagnostics } from "../components/Diagnostics/Diagnostics";
import { GenreBlend } from "../components/GenreBlend/GenreBlend";
import { MainControls } from "../components/MainControls/MainControls";
import { StartScreen } from "../components/StartScreen/StartScreen";
import { TransportControls } from "../components/TransportControls/TransportControls";
import { useAudioEngine } from "../hooks/useAudioEngine";
import { useControls } from "../hooks/useControls";
import { useEngineSnapshot } from "../hooks/useEngineSnapshot";

export function App() {
  const snapshot = useEngineSnapshot();
  const { controls, set } = useControls();
  const actions = useAudioEngine();

  const started = snapshot.status !== "idle" && snapshot.status !== "failed";

  if (!started) {
    return (
      <StartScreen
        onStart={actions.start}
        onRetry={actions.retry}
        busy={actions.busy}
        failed={snapshot.status === "failed"}
        lastError={snapshot.diagnostics.lastError}
      />
    );
  }

  return (
    <div className="app">
      <header className="app__header">
        <h1 className="app__title">Web Improvisation</h1>
        <p className="app__phase">Phase 1A — Rhythm Foundation</p>
      </header>

      <TransportControls
        snapshot={snapshot}
        controls={controls}
        actions={actions}
        setControl={set}
      />

      <GenreBlend controls={controls} snapshot={snapshot} setControl={set} />

      <MainControls controls={controls} snapshot={snapshot} setControl={set} />

      <Diagnostics snapshot={snapshot} />

      <footer className="app__footer">
        <p>入力音の解析はPhase 2で追加します。現時点でマイク権限は要求しません。</p>
      </footer>
    </div>
  );
}
